import { ReactNode } from 'react';
import classNames from 'classnames';

import Help from '@/components/Help';

type Props = {
  title: ReactNode;
  description?: string | string[];
  helpFor?: Parameters<typeof Help>[0]['for'];
  children?: ReactNode;
  className?: string;
  buttons?: ReactNode;
};

/** 페이지 헤더 - 설명 */
const Description = ({ description }: Pick<Props, 'description'>) => {
  if (!description) return null;

  if (typeof description === 'string') {
    return <p className="desc_g">{description}</p>;
  }

  return (
    <ul className="list_tit">
      {description.map((text, index) => (
        <li key={index} className="desc_g">
          {text}
        </li>
      ))}
    </ul>
  );
};

/** 페이지 헤더(타이틀, 설명, 도움말 보러가기 등) */
const PageHeader = ({ title, description, helpFor, children, className, buttons }: Props) => {
  return (
    <div className={classNames('wrap_tit', className)}>
      <div className="group_tit">
        <div className="wrap_heading">
          <h3 className="tit_g">{title}</h3>
          {helpFor && <Help for={helpFor} />}
        </div>
        <Description description={description} />
        {children}
      </div>
      {buttons && <div className="group_btn">{buttons}</div>}
    </div>
  );
};

export default PageHeader;
